import {useCallback} from 'react';
import {useAppSelector} from "../../../redux/hooks";
import {
  getIsMySongsPageFilterGenreIdSelected
} from "../../../pages/songs-router/modules/my-songs-page-store/mySongsPage.selectors";
import {mySongsPageStore} from "../../../pages/songs-router/modules/my-songs-page-store/mySongsPage.store";
import {mySongsFiltersStore} from "../../../pages/songs-router/modules/my-songs-filters-store/mySongsFiltersStore";

export interface IFilterGenreLogic {
  title?: string;
  isSelected: boolean;
  handleToggleOnClick: () => void;
}

export const useFilterGenreLogic = (genreId: number): IFilterGenreLogic => {
  const title = useAppSelector(() => mySongsFiltersStore.getGenreFromId(genreId)?.name)
  const isSelected = useAppSelector((store) => getIsMySongsPageFilterGenreIdSelected(store, genreId));
  const handleToggleOnClick = useCallback(() => {
    mySongsPageStore.toggleFilterGenreId(genreId);
  }, [genreId]);
  return {
    title,
    isSelected,
    handleToggleOnClick,
  };
}
